/* JDORA メタリック：動きの演出（外部の読み込みなし・個人情報は扱わない） */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // スクロールで下からふわっと現れる
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var groups = [
      '.mx-head',
      '.mx-chips__row',
      '.mx-products .grid__item',
      '.mx-rail__item',
      '.mx-ed__body > *',
      '.mx-promise__head',
      '.mx-promise__item',
      '.collection .grid__item, #product-grid .grid__item'
    ];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    groups.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el, i) {
        if (el.classList.contains('mx-rv')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) return; // 最初から見えている所は動かさない
        el.classList.add('mx-rv');
        el.style.setProperty('--mx-d', Math.min(i % 4, 3) * 0.08 + 's');
        io.observe(el);
      });
    });
  }

  // メインビジュアル：マウスの位置に淡い光がついてくる
  function spotlight() {
    if (reduce) return;
    var hero = document.querySelector('.mx-hero');
    if (!hero || !window.matchMedia('(pointer: fine)').matches) return;
    var raf = 0;
    hero.addEventListener('pointermove', function (ev) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var b = hero.getBoundingClientRect();
        hero.style.setProperty('--mx-x', ((ev.clientX - b.left) / b.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--mx-y', ((ev.clientY - b.top) / b.height * 100).toFixed(1) + '%');
      });
    });
  }

  // 特集の写真：マウスに合わせてほんの少し傾く
  function tilt() {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.mx-ed__media'), function (el) {
      el.style.transition = 'transform .6s cubic-bezier(.22,.61,.36,1)';
      el.addEventListener('pointermove', function (ev) {
        var b = el.getBoundingClientRect();
        var x = (ev.clientX - b.left) / b.width - 0.5;
        var y = (ev.clientY - b.top) / b.height - 0.5;
        el.style.transform = 'perspective(1200px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function init() { reveal(); spotlight(); tilt(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
